import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { priceFormatter } from 'utils/formatters';
import EditPriceModal from 'components/EditPrice';
import { FONTS } from 'styles/theme/fonts';
import { COLORS } from 'styles/theme/colors';

export const DisplayPrice = ({ product, isStorePrice }) => {
  const priceDollars = priceFormatter(product.priceCents);
  const [isVisible, setIsVisible] = useState(false);
  const [isEnabled] = useState(true);

  const handleClick = () => {
    setIsVisible(true);
  };

  const handleCancel = () => {
    setIsVisible(false);
  };

  return (
    <DisplayPrice.Container>
      <DisplayPrice.PriceButton isStorePrice={isStorePrice} onClick={handleClick}>
        {isStorePrice ? 'Store Price' : `$${priceDollars}`}
      </DisplayPrice.PriceButton>
      <EditPriceModal
        modalVisible={isVisible && isEnabled}
        onCancel={handleCancel}
        product={product}
      />
    </DisplayPrice.Container>
  );
};

DisplayPrice.Container = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

DisplayPrice.PriceButton = styled.button`
  width: ${({ isStorePrice }) => (isStorePrice ? '128px' : '126px')};
  min-height: 37px;
  margin-right: 4px;
  background-color: ${COLORS.primaryButtonBackground};
  border: none;
  font-size: 20px;
  line-height: 20px;
  color: ${COLORS.primaryText};
  font-family: ${FONTS.special};
  cursor: pointer;

  &:focus {
    outline: none;
  }
`;

DisplayPrice.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    status: PropTypes.string,
  }),
};

export default DisplayPrice;
